var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSinglePoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 32,
    viewBox: "0 0 63 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 13C4 7.47715 8.47715 3 14 3H49C54.5228 3 59 7.47715 59 13V13C59 18.5228 54.5228 23 49 23H35.5L31.5 27L27.5 23H14C8.47715 23 4 18.5228 4 13V13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8536 22.6464L27.7071 22.5H27.5H14C8.7533 22.5 4.5 18.2467 4.5 13C4.5 7.75329 8.7533 3.5 14 3.5H49C54.2467 3.5 58.5 7.75329 58.5 13C58.5 18.2467 54.2467 22.5 49 22.5H35.5H35.2929L35.1464 22.6464L31.5 26.2929L27.8536 22.6464Z",
    stroke: "#1E88E5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 13C22 12.2637 21.5371 11.6348 20.8848 11.3906C21.1719 10.7578 21.0566 9.98633 20.5352 9.46484C20.0137 8.94336 19.2422 8.82812 18.6094 9.11523C18.3652 8.46289 17.7363 8 17 8C16.2637 8 15.6348 8.46289 15.3906 9.11523C14.7578 8.82812 13.9844 8.94336 13.4648 9.46484C12.9434 9.98633 12.8281 10.7578 13.1152 11.3906C12.4629 11.6348 12 12.2637 12 13C12 13.7363 12.4629 14.3652 13.1152 14.6094C12.8281 15.2422 12.9434 16.0156 13.4648 16.5352C13.9844 17.0547 14.7559 17.1738 15.3906 16.8848C15.6348 17.5352 16.2637 18 17 18C17.7363 18 18.3652 17.5371 18.6094 16.8848C19.2461 17.1738 20.0156 17.0547 20.5352 16.5352C21.0566 16.0137 21.1719 15.2422 20.8848 14.6094C21.5371 14.3652 22 13.7363 22 13V13ZM17.4688 14.8445V15.1875C17.4688 15.3602 17.3289 15.5 17.1562 15.5H16.8438C16.6711 15.5 16.5312 15.3602 16.5312 15.1875V14.8412C16.3082 14.8148 16.0961 14.7398 15.9105 14.6174C15.7891 14.5371 15.7773 14.3613 15.8803 14.2584L16.2225 13.9162C16.2955 13.8432 16.4043 13.8334 16.498 13.8766C16.5602 13.9051 16.6281 13.9199 16.6984 13.9199H17.3387C17.4297 13.9199 17.5035 13.8461 17.5035 13.7555C17.5035 13.6822 17.4543 13.6172 17.384 13.5971L16.4061 13.3178C15.9715 13.1937 15.6246 12.8352 15.568 12.3867C15.4889 11.7604 15.9396 11.226 16.5312 11.1553V10.8125C16.5312 10.6398 16.6711 10.5 16.8438 10.5H17.1562C17.3289 10.5 17.4688 10.6398 17.4688 10.8125V11.1588C17.6918 11.1852 17.9039 11.2602 18.0895 11.3826C18.2109 11.4629 18.2227 11.6387 18.1197 11.7416L17.7775 12.0838C17.7045 12.1568 17.5957 12.1666 17.502 12.1234C17.4391 12.0947 17.3707 12.0799 17.3016 12.0801H16.6613C16.5703 12.0801 16.4965 12.1539 16.4965 12.2445C16.4965 12.3178 16.5457 12.3828 16.616 12.4029L17.5939 12.6822C18.0285 12.8064 18.3754 13.1648 18.432 13.6133C18.5111 14.2395 18.0604 14.7738 17.4688 14.8445V14.8445Z",
    fill: "#1E88E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 63,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinglePoint);
export default __webpack_public_path__ + "static/media/single_point.8239f7cb95d52d72163858b453807f43.svg";
export { ForwardRef as ReactComponent };